import { render, staticRenderFns } from "./CreateReport.vue?vue&type=template&id=245f8e26&"
import script from "./CreateReport.vue?vue&type=script&lang=ts&"
export * from "./CreateReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports